import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const Avatar = ({ name, size = 40 }) => {
  const initials =
    name
      ?.split(' ')
      ?.map((n) => n[0])
      ?.join('')
      ?.slice(0, 2)
      ?.toUpperCase() || '';
  return (
    <div
      className="rounded-full bg-gradient-to-br from-red-400 to-red-600 flex items-center justify-center text-white font-bold shrink-0 shadow-sm"
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {initials}
    </div>
  );
};

export default function UnplannedLeaveCard({ leave, onAddLeave }) {
  const displayName = leave?.user
    ? `${leave.user.first_name} ${leave.user.last_name}`
    : 'Unknown Employee';

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="group bg-white flex justify-between items-end border border-red-200/70 rounded-xl p-4 hover:border-red-300 hover:shadow-md transition-all duration-300"
    >
      <div className="flex items-end gap-3">
        <Avatar name={displayName} size={40} />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <h4 className="text-sm font-semibold text-slate-900 truncate">{displayName}</h4>
              {leave?.user?.department && (
                <p className="text-[11px] text-slate-400 mt-0.5">{leave.user.department}</p>
              )}
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2 mt-2">
            <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-semibold border bg-red-50 text-red-700 border-red-200">
              Unplanned
            </span>
          </div>
        </div>
      </div>

      {onAddLeave && (
        <div className="">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onAddLeave(leave);
            }}
            className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-red-50 text-red-700 rounded-lg text-xs font-semibold hover:bg-red-100 transition-colors"
          >
            <Icon name="UserPlus" size={12} />
            Add Leave
          </button>
        </div>
      )}
    </motion.div>
  );
}
